<template>
  <!-- summary dialog -->
  <v-dialog
    v-model="pdfDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar flat color="secondary" dense>
        <v-toolbar-title>
          <v-btn icon @click.native="pdfDialog = false">
            <v-icon dark>mdi-keyboard-backspace</v-icon>
          </v-btn>
          Document Preview 
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="pdfDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container class="docForm">
          <v-row justify="center">
            <v-col cols="12">
              <iframe :src="pdfDoc" width="100%" height="800px"></iframe>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- end -->
</template>
<script>
export default {
  name: "AppSnackbar",
  props: {
    timeout: {
      type: Number,
      default: 6000,
    },
  },
  data() {
    return {
      pdfDialog: false,
      pdfDoc: null,
    };
  },
  methods: {
    show(data) {
      this.pdfDoc = data;
      this.pdfDialog = true;
    },
  },
};
</script>
